import { uniq } from '../utils';
/**
 * Parse list of categories from `cdnSettings.integration.myIntegration` object
 * @example
 * returns ["Analytics", "Advertising"]
 */
export var parseConsentCategories = function parseConsentCategories(integration) {
  if (integration && typeof integration === 'object' && 'consentSettings' in integration && typeof integration.consentSettings === 'object' && integration.consentSettings && 'categories' in integration.consentSettings && Array.isArray(integration.consentSettings.categories)) {
    return integration.consentSettings.categories || undefined;
  }
  return undefined;
};
export var parseAllCategories = function parseAllCategories(integrationCategoryMappings) {
  return uniq(Object.values(integrationCategoryMappings).reduce(function (p, n) {
    return p.concat(n);
  }));
};